var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayVideoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M45 90C69.8528 90 90 69.8528 90 45C90 20.1472 69.8528 0 45 0C20.1472 0 0 20.1472 0 45C0 69.8528 20.1472 90 45 90Z",
    fill: "#7fad29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3178 46.7028L36.1537 64.595C35.7933 64.8242 35.367 64.962 34.9222 64.9932C34.4773 65.0244 34.0312 64.9478 33.6333 64.7718C33.2354 64.5958 32.9012 64.3273 32.6678 63.996C32.4343 63.6648 32.3107 63.2838 32.3105 62.8951V27.1049C32.3107 26.7163 32.4343 26.3352 32.6678 26.004C32.9012 25.6728 33.2354 25.4043 33.6333 25.2283C34.0312 25.0523 34.4773 24.9756 34.9222 25.0068C35.367 25.038 35.7933 25.1758 36.1537 25.405L64.3178 43.3001C64.6254 43.4956 64.8756 43.7516 65.0481 44.0472C65.2206 44.3429 65.3105 44.6698 65.3105 45.0014C65.3105 45.3331 65.2206 45.66 65.0481 45.9557C64.8756 46.2513 64.6254 46.5073 64.3178 46.7028Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayVideoIcon);
export default __webpack_public_path__ + "static/media/play-video-icon.7482a7d3.svg";
export { ForwardRef as ReactComponent };